import { toJS } from 'mobx'
import { parseUTCDate } from 'src/utils'

export function isTodayIsCurrentProcessingDay(props) {
  const {
    freezeOrderDate,
    orderProcessingDate,
    lastOrderProcessingDate,
    currentDate = '',
    selectedMonth,
    //startMonth,
  } = props

  const lastOrderDate = new Date(lastOrderProcessingDate)
  const lastOrderDay = lastOrderDate.getDate()
  const lastOrderProcessedMonth = lastOrderDate.getMonth()
  const dateNow = parseUTCDate(currentDate || '')
  const todaysDate = dateNow.getDate()
  const currentMonth = dateNow.getMonth()
  if (
    todaysDate === lastOrderDay &&
    lastOrderProcessedMonth !== currentMonth &&
    selectedMonth != currentMonth + 1
  ) {
    return true
  } else if (
    todaysDate >= freezeOrderDate &&
    todaysDate <= orderProcessingDate &&
    lastOrderProcessedMonth !== currentMonth
  ) {
    console.log(
      'process now c2 todaysDate >= freezeOrderDate && todaysDate <= orderProcessingDate && lastOrderProcessedMonth !== currentMonth'
    )
    return true
  } else if (
    freezeOrderDate >= orderProcessingDate &&
    todaysDate <= orderProcessingDate &&
    lastOrderProcessedMonth !== currentMonth
  ) {
    console.log(
      'process now c3 freezeOrderDate >= orderProcessingDate && todaysDate <= orderProcessingDate && lastOrderProcessedMonth !== currentMonth'
    )
    return true
  }
  console.log('process now false')
  return false
}

export function isSubscriptionEditable(
  currentMonth,
  selectedMonth,
  lastOrderProcessedMonth
) {
  // to enable subscription edit
  // if (selectedMonth == currentMonth),  currentmonth should not be a processed month
  // else we should enable ONLY the next month of processedmonth
  // ^this will work only if feed runs everymonth
  // ^if not, won't work for user with frequency like 'every two months'

  // THIS IS A COMMON CODE FOR MULTIPLE PLACES
  // BE CAUTIOUS ABOUT REGRESSION

  const isNextMonthOfCurrentMonthSelected =
    currentMonth == 11 ? selectedMonth == 0 : selectedMonth == currentMonth + 1
  const enableSubscriptionEdit =
    selectedMonth == currentMonth
      ? lastOrderProcessedMonth != currentMonth
      : isNextMonthOfCurrentMonthSelected &&
        lastOrderProcessedMonth == currentMonth

  return enableSubscriptionEdit
}

function filterUniqueItemsInFrequency(subscriptionItems = []) {
  const uniqueSubscriptionItems = []
  const itemIdSet = new Set()
  for (const item of subscriptionItems) {
    const itemId = item.id || ''
    if (!itemIdSet.has(itemId)) {
      itemIdSet.add(itemId)
      uniqueSubscriptionItems.push(item)
    }
  }
  return uniqueSubscriptionItems
}

function constructKeys(item) {
  const itemInfo = item?.itemInfo?.[0] || {}
  const itemId = itemInfo?.skus?.[0]?.id || ''
  const frequencyPeriod = item?.frequencyPeriod || ''
  const frequencyType = item?.frequencyType || ''
  const quantity = itemInfo?.quantity || ''
  const key = [itemId, frequencyPeriod, frequencyType, quantity].join('-')

  return key
}

// subscription id will be different for processed(shipping) items and upcoming items
// compare skuId, frequencyPeriod, frequencyType and quantity and remove the repeated products
function filterOtherItemsFromShipping(shippingItems, otherItems) {
  const filteredOtherItems = []
  const shippingItemsKeys = []
  for (const shippingItem of shippingItems) {
    const shippingKey = constructKeys(shippingItem)
    shippingItemsKeys.push(shippingKey)
  }

  for (const otherItem of otherItems) {
    const otherItemKey = constructKeys(otherItem)
    if (!shippingItemsKeys.includes(otherItemKey)) {
      filteredOtherItems.push(otherItem)
    }
  }

  return filteredOtherItems
}

// separates the products which are being shipped for current month (sorted by frequency) on top of the list,
// and then will list the rest of the products (also sorted by frequency).
function separateImmediateMonthProducts(
  itemsByFrequency,
  currentMonth,
  lastOrderProcessedMonth,
  lastSubscriptionOrderStatus
) {
  const frequencyPrecedence = ['months-1', 'months-2', 'months-3']
  const shippingItems = []
  const otherItems = []
  for (const frequency of frequencyPrecedence) {
    if (frequency in itemsByFrequency) {
      const frequencyItems = itemsByFrequency[frequency]

      for (const item of frequencyItems) {
        const selectedMonth = item.selectedMonth
        // 1.current month == order_success
        //  HIDE current month products, SHOW upcoming month products
        // 2.current month != order_success
        //  SHOW current month products with SHIPPING icon, SHOW upcoming month products

        // current month == order_success
        const isCurrentMonthOrderSuccess =
          lastOrderProcessedMonth == selectedMonth &&
          lastSubscriptionOrderStatus.toLowerCase() == 'order_success'
        if (selectedMonth == currentMonth && isCurrentMonthOrderSuccess) {
          continue
        }
        // current month != order_success
        if (selectedMonth == currentMonth) {
          item.isShipping = true
          item.isCurrentMonthProduct = true
          shippingItems.push(item)
        } else {
          otherItems.push(item)
        }
      }
    }
  }
  const filteredOtherItems = filterOtherItemsFromShipping(
    shippingItems,
    otherItems
  )
  return [...shippingItems, ...filteredOtherItems]
}

/* 
  1. Split products in all months by subscription frequency.
  2. Filter unique products in the each frequency.
  3. Sort products by their shipping status in each frequency.
*/

export function transformShowAllResponse(
  currentMonth,
  lastOrderProcessedMonth,
  lastSubscriptionOrderStatus,
  showAllResponse = [],
  isMigratedSubscription = false
) {
  const showAllSubscriptionData = [...showAllResponse]
  /*
    itemsByFrequency = <frequencyKey, [subscription products]>
    eg:
      {
        "months-1": [subscription products],
        "months-2":  [subscription products]
      }
  */
  const itemsByFrequency = {}
  const uniqueItemsInFrequency = {}
  // separate items by frequency
  for (const selectedSubscription of showAllSubscriptionData) {
    const { subscriptions = [], selectedMonth = '' } = selectedSubscription
    const currentMonthAlreadySucceeded =
      lastOrderProcessedMonth == selectedMonth &&
      lastSubscriptionOrderStatus.toLowerCase() == 'order_success'
    if (!currentMonthAlreadySucceeded) {
      for (const currentItem of subscriptions) {
        if (currentItem?.enableItemLevelProcessing === isMigratedSubscription) {
          const currentProduct = toJS(currentItem)
          const { frequencyType = '', frequencyPeriod } = currentProduct
          const frequencyKey = `${frequencyType.toLowerCase()}-${frequencyPeriod}`
          currentProduct.selectedMonth = selectedMonth

          if (frequencyKey in itemsByFrequency) {
            // if key exists, push the item to array
            itemsByFrequency[frequencyKey].push(currentProduct)
          } else {
            // create an array and push the item
            itemsByFrequency[frequencyKey] = [currentProduct]
          }
        }
      }
    }
  }
  // remove repeated products in each frequency
  Object.entries(itemsByFrequency).forEach(([key, products]) => {
    uniqueItemsInFrequency[key] = filterUniqueItemsInFrequency(products)
  })
  const sortedSubscriptionItems = separateImmediateMonthProducts(
    uniqueItemsInFrequency,
    currentMonth,
    lastOrderProcessedMonth,
    lastSubscriptionOrderStatus
  )
  return sortedSubscriptionItems
}
export function sortingPvItem(item) {
  item.sort(function (a, b) {
    return (
      a.itemInfo[0].properties.itempriority -
      b.itemInfo[0].properties.itempriority
    )
  })
  return item
}
